import { resetAppState } from 'core/store/reducers/appReducer/AppSlice';
import { resetAssetState } from 'core/store/reducers/assetsReducer/AssetsSlice';
import { resetCanvasState } from 'core/store/reducers/canvasReducer/CanvasSlice';
import { resetCharacterState } from 'core/store/reducers/characterStudioReducer/CharaterStudioSlice';
import { resetHomeState } from 'core/store/reducers/homeReducer/HomeSlice';
import { resetIntermediateState } from 'core/store/reducers/intermediateMediaReducer/IntermediateMediaSlice';
import { resetStudioState } from 'core/store/reducers/studioReducer/StudioSlice';

export const resetSliceStatesData = () => (dispatch) => {
	dispatch(resetAppState());
	dispatch(resetStudioState());
	dispatch(resetCanvasState());
	dispatch(resetAssetState());
	dispatch(resetCharacterState());
	dispatch(resetIntermediateState());
	dispatch(resetHomeState());
};
